import { TranslateService } from '@ngx-translate/core';
import { PackageBuilderService } from "app/package-builder/package-builder.service";
import { ProductDetailsModel } from "app/core/models/product-details-model.model";
import { GenericSummaryCardDtoResponse } from "app/core/models/generic-summary-card.dto-response";
import { Constants, AccessoryCategory } from "app/core/Constants";
import { SettingService } from '../setting.service';
import { ProductNotesService } from './product-notes.service';
import { Warnings } from 'app/core/models/warnings.model';
import { User } from 'app/core/User';
import { Helper } from '../helper';
import { LeadTimeDtoResponse } from '../../core/models/lead-time-dto-response';
import { OETireSizeFitmentNote } from '../../core/models/oe-tire-size-fitment.dto-response';

export class WarningsSetupService {
  static productNotesService: ProductNotesService;

  constructor(
    productNotesServiceParam: ProductNotesService
  ) {
    WarningsSetupService.productNotesService = productNotesServiceParam;
  }

  static async setupWarnings(packageBuilderService: PackageBuilderService, translateService: TranslateService, settingService: SettingService, frontQty: number, rearQty: number, card: GenericSummaryCardDtoResponse, hasVehicleInfo: boolean, isWheelsByVehicle: boolean, mtlWheelDrillLeadTime: LeadTimeDtoResponse): Promise<Warnings> {
    // djb:note-it is not clear why some push to warningNotes and some to warningsArray
    let warningsList = new Warnings();
    warningsList.warnings = new Array<string>();

    let showShipfromMTLWarning: boolean = false; 
    let showWheelDrillWarning: boolean = false;
    let showBackOrderWarning: boolean = false;
    let showAlternateWarehouseWarning: boolean = false;
    let showTPMSConfiguredWarning: boolean = false;
    let showTPMSConfigurationRequiredWarning: boolean = false;
    let showDiscontinuedNoBackOrderWarning: boolean = false;
    let showClearanceNoBackOrderWarning: boolean = false;
    let showSpecialNoBackOrderWarning: boolean = false;
    let showParkedNoBackOrderWarning: boolean = false;
    let showSpacerWarning: boolean = false;
    let includeNotWinterWheelWarning: boolean = true;
    let showMtl3PLWarning: boolean = false;
    let showMtl3PLBlankWarning: boolean = false;
    let leadTime: LeadTimeDtoResponse = null;
    //let leadTimeUOM: string = '';
    //let leadTimeValue: string = '';
    let diff: number = 0;
    let diffInUOM: number = 0;
    let picLeadTime: LeadTimeDtoResponse = null;
    let picDiff: number = 0;
    let picDiffInUOM: number = 0;

    if (card.frontProduct && card.frontProduct.warningNotes == null) {
      card.frontProduct.warningNotes = [];
    }
    if (card.rearProduct && card.rearProduct.warningNotes == null) {
      card.rearProduct.warningNotes = [];
    }

    if (card.frontProduct.defaultWarehouse === "MTL") {
      if (card.frontProduct.hasAlternateWarehouseMtl || card.frontProduct.hasAlternateWarehousePic) {
        if (card.frontProduct.onHandDetails && card.frontProduct.onHandDetails.length > 0) {
          let actualOnHand: number = 0;
          if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
            card.frontProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
              .forEach(det => {
                actualOnHand += det.qty;
              });
          else
            actualOnHand = card.frontProduct.inventory.onHandQtyMtl === null && card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyPic;
          let alternateWarehouse: number = 0;
          if (card.frontProduct.onHandDetails.some(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC")))
            card.frontProduct.onHandDetails.filter(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC"))
              .forEach(det => {
                alternateWarehouse += det.qty;
              });
          let gtQty: number = 0;
          if (card.frontProduct.onHandDetails.some(d => d.label.startsWith("GT") && (d.label.endsWith("AltDetail.MTL") || d.label.endsWith("AltDetail.PIC")))) {
            card.frontProduct.onHandDetails.filter(d => d.label.startsWith("GT") && (d.label.endsWith("AltDetail.MTL") || d.label.endsWith("AltDetail.PIC")))
              .forEach(det => {
                gtQty += det.qty;
              });
          }

          if (User.canSplitOrders && User.allowShipFromCalgary) {
            if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.CAL"))
              actualOnHand += card.frontProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
            if (card.frontProduct.onHandDetails.find(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")))
              alternateWarehouse += card.frontProduct.onHandDetails.find(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")).qty;
          }
          if (card.frontProduct.inventory.mtl3PLStockQty > 0 &&
            actualOnHand - card.frontProduct.inventory.mtl3PLStockQty >= 0 &&
            frontQty > actualOnHand - card.frontProduct.inventory.mtl3PLStockQty) {
            showMtl3PLWarning = true;
          }
          if (frontQty > actualOnHand) {
            if (card.frontProduct.inventory.onOrderAvailQtyMTL > 0) {
              if (leadTime == null) {
                leadTime = await settingService.getLeadTime(card.productBrand, card.frontProduct.defaultWarehouse).first().toPromise();
                //if (leadTime == null || leadTime == '')
                //  leadTime = "72H";
                //leadTimeUOM = leadTime.substring(leadTime.length - 1);
                //leadTimeValue = leadTime.substring(0, leadTime.length - 1);
                diff = Date.parse(card.frontProduct.inventory.expectedDateMTL) - new Date().valueOf();
                diffInUOM = Math.floor(leadTime.unitOfMeasure === "D" ? diff / (60 * 60 * 24 * 1000) : leadTime.unitOfMeasure === "H" ? diff / (60 * 60 * 1000) : 0);
              }
              if (card.frontProduct.inventory.onOrderAvailQtyMTL < frontQty ||
                (card.frontProduct.inventory.onOrderAvailQtyMTL > frontQty && leadTime.value < diffInUOM))
                showAlternateWarehouseWarning = true;
            }
            else if (card.frontProduct.inventory.onOrderAvailQtyPIC > 0) {
              if (picLeadTime == null) {
                picLeadTime = await settingService.getLeadTime(card.productBrand, "PIC").first().toPromise();
                picDiff = Date.parse(card.frontProduct.inventory.expectedDatePIC) - new Date().valueOf();
                picDiffInUOM = Math.floor(picLeadTime.unitOfMeasure === "D" ? picDiff / (60 * 60 * 24 * 1000) : picLeadTime.unitOfMeasure === "H" ? picDiff / (60 * 60 * 1000) : 0);
              }
              if (card.frontProduct.inventory.onOrderAvailQtyPIC < frontQty ||
                (card.frontProduct.inventory.onOrderAvailQtyPIC > frontQty && picLeadTime.value < picDiffInUOM))
                showAlternateWarehouseWarning = true;
            }
            else
              showAlternateWarehouseWarning = true;

            if (card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
                showAlternateWarehouseWarning = frontQty > actualOnHand + gtQty;
            }

            if (actualOnHand + alternateWarehouse < frontQty) {
              if (card.frontProduct.productStatus === "D")
                showDiscontinuedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "P")
                showParkedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "C") {
                const _onOrderAvailQtyEast = card.frontProduct.inventory.onOrderAvailQtyMTL === null && card.frontProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.frontProduct.inventory.onOrderAvailQtyMTL + card.frontProduct.inventory.onOrderAvailQtyPIC;
                if (frontQty > _onOrderAvailQtyEast)
                  showClearanceNoBackOrderWarning = true;
              }
              else if (card.frontProduct.isSpecial && !User.isFastcoRole) {
                let _onHandQty: number = 0;
                if (card.frontProduct.inventory.onHandQtyMtl !== null)
                  _onHandQty += card.frontProduct.inventory.onHandQtyMtl;
                if (card.frontProduct.inventory.onHandQtyCal !== null)
                  _onHandQty += card.frontProduct.inventory.onHandQtyCal;
                if (card.frontProduct.inventory.onHandQtyPic !== null)
                  _onHandQty += card.frontProduct.inventory.onHandQtyPic;
                if (frontQty > _onHandQty)
                  showSpecialNoBackOrderWarning = true;
                else
                  showBackOrderWarning = true;
              }
            }
          }
        }
      }
      else if (card.frontProduct.isDrilled) {
        if (card.frontProduct.onHandDetails && card.frontProduct.onHandDetails.length > 0) {
          let actualOnHand: number = 0;
          if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
            card.frontProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
              .forEach(det => {
                actualOnHand += det.qty;
              });
          else
            actualOnHand = card.frontProduct.inventory.onHandQtyMtl === null && card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyPic;

          let actualLocalOnHand: number = actualOnHand;
          let _3PLQty: number = 0;
          let _3PLBlankQty: number = card.frontProduct.inventory.mtl3PLBlankStockQty;
          if (card.frontProduct.has3PL) {
            _3PLQty = card.frontProduct.onHandDetails.filter(d => d.label.endsWith('3PL.WarehouseDetail.MTL')).reduce((sum, current) => sum + current.qty, 0);
            actualLocalOnHand -= _3PLQty;
          }

          const processRequired = card.frontProduct.onHandDetails.find(d => d.label === "FC.Inventory.ProcessRequired.MTL").qty;
          let blankActualLocalOnHand: number = processRequired - _3PLBlankQty;

          if (User.canSplitOrders && User.allowShipFromCalgary) {
            if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.CAL"))
              actualOnHand += card.frontProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
            else if (card.frontProduct.inventory.onHandQtyCal !== null)
              actualOnHand += card.frontProduct.inventory.onHandQtyCal;
          }
          if (card.frontProduct.inventory.mtl3PLStockQty > 0 &&
            actualLocalOnHand >= 0 &&
            frontQty > actualLocalOnHand) {
            showMtl3PLWarning = true;
          }
          if (frontQty > actualOnHand) {
            showWheelDrillWarning = true;
            if (actualOnHand + processRequired >= frontQty) {
              if (actualOnHand + blankActualLocalOnHand < frontQty)
                showMtl3PLBlankWarning = true;
            }
            else if (actualOnHand + processRequired < frontQty) {
              if (card.frontProduct.productStatus === "D")
                showDiscontinuedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "P")
                showParkedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "C") {
                const _onOrderAvailQtyEast = card.frontProduct.inventory.onOrderAvailQtyMTL === null && card.frontProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.frontProduct.inventory.onOrderAvailQtyMTL + card.frontProduct.inventory.onOrderAvailQtyPIC;
                if (frontQty > _onOrderAvailQtyEast)
                  showClearanceNoBackOrderWarning = true;
              }
              else if (card.frontProduct.isSpecial && !User.isFastcoRole)
                showSpecialNoBackOrderWarning = true;
              else
                showBackOrderWarning = true;
            }
          }
        }
      }
      else if (User.canSplitOrders && User.allowShipFromCalgary) {
        let _onHandQty: number = 0;
        if (card.frontProduct.inventory.onHandQtyMtl !== null)
          _onHandQty += card.frontProduct.inventory.onHandQtyMtl;
        if (card.frontProduct.inventory.onHandQtyCal !== null)
          _onHandQty += card.frontProduct.inventory.onHandQtyCal;
        if (card.frontProduct.inventory.onHandQtyPic !== null)
          _onHandQty += card.frontProduct.inventory.onHandQtyPic;
        const hasStock = frontQty > _onHandQty;
        if (card.frontProduct.productStatus === "D" && hasStock) {
          showDiscontinuedNoBackOrderWarning = true;
        }
        else if (card.frontProduct.productStatus === "P" && hasStock)
          showParkedNoBackOrderWarning = true;
        else if (card.frontProduct.productStatus === "C" && hasStock) {
          let _onOrderAvailQty: number = 0;
          if (card.frontProduct.inventory.onOrderAvailQtyMTL !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyMTL;
          if (card.frontProduct.inventory.onOrderAvailQtyCAL !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyCAL;
          if (card.frontProduct.inventory.onOrderAvailQtyPIC !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyPIC;

          if (frontQty > (_onOrderAvailQty + _onHandQty))
            showClearanceNoBackOrderWarning = true;
        }
        else if (card.frontProduct.isSpecial && !User.isFastcoRole && hasStock)
          showSpecialNoBackOrderWarning = true;
        else if (frontQty > card.frontProduct.inventory.onHandQtyMtl)
          showBackOrderWarning = true;
        if (card.frontProduct.inventory.mtl3PLStockQty > 0 &&
          card.frontProduct.inventory.onHandQtyMtl - card.frontProduct.inventory.mtl3PLStockQty >= 0 &&
          frontQty > card.frontProduct.inventory.onHandQtyMtl - card.frontProduct.inventory.mtl3PLStockQty) {
          showMtl3PLWarning = true;
        }
      }
      else if (frontQty > card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyPic) {
        if (card.frontProduct.productStatus === "D") {
          if (frontQty > card.frontProduct.inventory.onHandQtyCal)//bk 2021/02/22 - warning will only show if cal qty < frontQty
            showDiscontinuedNoBackOrderWarning = true;
        }
        else if (card.frontProduct.productStatus === "P") {
          if (frontQty > card.frontProduct.inventory.onHandQtyCal)//bk 2021/02/22 - warning will only show if cal qty < frontQty
            showParkedNoBackOrderWarning = true;
        }
        else if (card.frontProduct.productStatus === "C") {
          let _onOrderAvailQty: number = 0;
          if (card.frontProduct.inventory.onOrderAvailQtyMTL !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyMTL;
          if (card.frontProduct.inventory.onOrderAvailQtyCAL !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyCAL;
          if (card.frontProduct.inventory.onOrderAvailQtyPIC !== null)
            _onOrderAvailQty += card.frontProduct.inventory.onOrderAvailQtyPIC;
          if (frontQty > _onOrderAvailQty)
            showClearanceNoBackOrderWarning = true;
        }
        else if (card.frontProduct.isSpecial && !User.isFastcoRole) {
          let _onHandQty: number = 0;
          if (card.frontProduct.inventory.onHandQtyMtl !== null)
            _onHandQty += card.frontProduct.inventory.onHandQtyMtl;
          if (card.frontProduct.inventory.onHandQtyCal !== null)
            _onHandQty += card.frontProduct.inventory.onHandQtyCal;
          if (card.frontProduct.inventory.onHandQtyPic !== null)
            _onHandQty += card.frontProduct.inventory.onHandQtyPic;
          if (frontQty > _onHandQty)
            showSpecialNoBackOrderWarning = true;
        }
        else
          showBackOrderWarning = true;
      }
      else if (card.frontProduct.inventory.mtl3PLStockQty > 0 &&
        card.frontProduct.inventory.onHandQtyMtl - card.frontProduct.inventory.mtl3PLStockQty >= 0 &&
        frontQty > card.frontProduct.inventory.onHandQtyMtl - card.frontProduct.inventory.mtl3PLStockQty) {
        showMtl3PLWarning = true;
      }

      const _3PLLeadTime = await settingService.getMTL3PLLeadTime().first().toPromise();
      //const _3PLLeadTimeValue = _3PLLeadTime.substring(0, _3PLLeadTime.length - 1);
      let _3PLMessage: string = Helper.stringFormat(translateService.instant('FC.LeadTime.Delay.3PL.InternalNotes'), _3PLLeadTime.value, translateService.instant(`FC.LeadTime.${_3PLLeadTime.unitOfMeasure}`));
      if (showMtl3PLWarning || showMtl3PLBlankWarning) {
        if (!card.frontProduct.warningNotes.some(n => n === _3PLMessage))
          card.frontProduct.warningNotes.push(_3PLMessage);
      }
      else {
        let ndx: number = card.frontProduct.warningNotes.findIndex(x => x === _3PLMessage);
        if (ndx > -1) {
          card.frontProduct.warningNotes.splice(ndx, 1);
        }
      }

      if (card.frontProduct.inventory.procurementLeadTime !== null) {
        let msg = translateService.instant('FC.ProductWarningsNotes.ProcurementLeadTime').replace('[ProcurementLeadTime]', card.frontProduct.inventory.procurementLeadTime);
        warningsList.warnings.push(msg);
        showBackOrderWarning = false;
      }

      if (card.frontProduct.isSpecial) {
        const _isTire = card.productType === 'Tire' || card.productTypeWarning === 'Tire';
        const _isWheel = card.productType === 'Wheel' || card.productTypeWarning === 'Wheel';

        if (_isTire || _isWheel) {
          let actualOnHand: number = 0;

          if (card.frontProduct.onHandDetails && card.frontProduct.onHandDetails.length > 0) {
            const mtlStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.MTL');

            if (mtlStock)
              actualOnHand = mtlStock.qty;

            if (_isWheel) {
              let mtlAlternateStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.AlternateWarehouse.MTL');

              if (!mtlAlternateStock)
                mtlAlternateStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.ProcessRequired.MTL');

              if (mtlAlternateStock)
                actualOnHand += mtlAlternateStock.qty;
            }

            if (!mtlStock && card.frontProduct.inventory)
              actualOnHand = card.frontProduct.inventory.onHandQtyMtl;

            const calStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.CAL');
            if (calStock)
              actualOnHand += calStock.qty;
            else if (card.frontProduct.inventory)
              actualOnHand += card.frontProduct.inventory.onHandQtyCal;

            const picStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.PIC');
            if (picStock && picStock.qty !== null)
              actualOnHand += picStock.qty;
            else if (card.frontProduct.inventory && card.frontProduct.inventory.onHandQtyPic !== null)
              actualOnHand += card.frontProduct.inventory.onHandQtyPic;

          } else if (card.frontProduct.inventory) {
            actualOnHand = card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic !== null ? card.frontProduct.inventory.onHandQtyPic : 0);
          }

          const _isBraelin = card.productBrand.toUpperCase().includes('BRAELIN');
          if (_isBraelin)
            actualOnHand = card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal;

          if (frontQty > actualOnHand) {
            warningsList.isOnSaleQtyMoreOnHand = true;
            warningsList.warnings.push(translateService.instant('FC.ProductWarningsNotes.OnSaleAvailableOnHand'));
          }
        }
      }

      // Optional Key backorder validation
      var isKey = card.frontProduct.details.details.find(d => d.accessoryType === AccessoryCategory.Keys);
      if (isKey) {
        const isOptionalKey = card.frontProduct['isOptionalKey'] && card.frontProduct['isOptionalKey'] === false;
        if (isOptionalKey !== undefined && !isOptionalKey) {
          if (card.frontProduct.inventory) {
            let onHandQtyMtl = card.frontProduct.inventory.onHandQtyMtl;
            if (onHandQtyMtl <= 0) {
              warningsList.warnings.push(translateService.instant('FC.Popup.OptionalKey.BackOrdered'));
              showBackOrderWarning = false;
            }
          }
        }
      }// End

      if (card.rearProduct) {
        let showMtl3PLWarningRear: boolean = false;
        let showMtl3PLBlankWarningRear: boolean = false;
        if (card.rearProduct.hasAlternateWarehouseMtl || card.rearProduct.hasAlternateWarehousePic) {
          if (card.rearProduct.onHandDetails && card.rearProduct.onHandDetails.length > 0) {
            let actualOnHand: number = 0;
            if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
              card.rearProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                .forEach(det => {
                  actualOnHand += det.qty;
                });
            else
              actualOnHand = card.rearProduct.inventory.onHandQtyMtl === null && card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyPic;
            let alternateWarehouse: number = 0;
            if (card.rearProduct.onHandDetails.some(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC")))
              card.rearProduct.onHandDetails.filter(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC"))
                .forEach(det => {
                  alternateWarehouse += det.qty;
                });
            let gtQty: number = 0;
            if (card.rearProduct.onHandDetails.some(d => d.label.startsWith("GT") && (d.label.endsWith("AltDetail.MTL") || d.label.endsWith("AltDetail.PIC")))) {
              card.rearProduct.onHandDetails.filter(d => d.label.startsWith("GT") && (d.label.endsWith("AltDetail.MTL") || d.label.endsWith("AltDetail.PIC")))
                .forEach(det => {
                  gtQty += det.qty;
                });
            }
            if (User.canSplitOrders && User.allowShipFromCalgary) {
              if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.CAL"))
                actualOnHand += card.rearProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
              if (card.rearProduct.onHandDetails.some(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")))
                alternateWarehouse += card.rearProduct.onHandDetails.find(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")).qty;
            }
            if (card.rearProduct.inventory.mtl3PLStockQty > 0 &&
              actualOnHand - card.rearProduct.inventory.mtl3PLStockQty >= 0 &&
              rearQty > actualOnHand - card.rearProduct.inventory.mtl3PLStockQty) {
              showMtl3PLWarning = true;
              showMtl3PLWarningRear = true;
            }
            if (rearQty > actualOnHand) {
              if (card.rearProduct.inventory.onOrderAvailQtyMTL > 0) {
                if (leadTime == null) {
                  leadTime = await settingService.getLeadTime(card.productBrand, card.rearProduct.defaultWarehouse).first().toPromise();
                  //if (leadTime == null || leadTime == '')
                  //  leadTime = "72H";
                  //leadTimeUOM = leadTime.substring(leadTime.length - 1);
                  //leadTimeValue = leadTime.substring(0, leadTime.length - 1);
                  diff = Date.parse(card.rearProduct.inventory.expectedDateMTL) - new Date().valueOf();
                  diffInUOM = Math.floor(leadTime.unitOfMeasure === "D" ? diff / (60 * 60 * 24 * 1000) : leadTime.unitOfMeasure === "H" ? diff / (60 * 60 * 1000) : 0);
                }
                if (card.rearProduct.inventory.onOrderAvailQtyMTL < rearQty ||
                  (card.rearProduct.inventory.onOrderAvailQtyMTL > rearQty && leadTime.value < diffInUOM))
                  showAlternateWarehouseWarning = true;
              }
              else if (card.rearProduct.inventory.onOrderAvailQtyMTL > 0) {
                if (picLeadTime == null) {
                  picLeadTime = await settingService.getLeadTime(card.productBrand, "PIC").first().toPromise();
                  picDiff = Date.parse(card.rearProduct.inventory.expectedDateMTL) - new Date().valueOf();
                  picDiffInUOM = Math.floor(picLeadTime.unitOfMeasure === "D" ? picDiff / (60 * 60 * 24 * 1000) : picLeadTime.unitOfMeasure === "H" ? picDiff / (60 * 60 * 1000) : 0);
                }
                if (card.rearProduct.inventory.onOrderAvailQtyMTL < rearQty ||
                  (card.rearProduct.inventory.onOrderAvailQtyMTL > rearQty && leadTime.value < diffInUOM))
                  showAlternateWarehouseWarning = true;
              }
              else if (card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
                if (rearQty > actualOnHand + gtQty)
                  showAlternateWarehouseWarning = true;
              }
              else
                showAlternateWarehouseWarning = true;

              if (actualOnHand + alternateWarehouse < rearQty) {
                if (card.rearProduct.productStatus === "D")
                  showDiscontinuedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "P")
                  showParkedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "C") {
                  const _onOrderAvailQtyEast = card.rearProduct.inventory.onOrderAvailQtyMTL === null && card.rearProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.rearProduct.inventory.onOrderAvailQtyMTL + card.rearProduct.inventory.onOrderAvailQtyPIC;
                  if (rearQty > _onOrderAvailQtyEast)
                    showClearanceNoBackOrderWarning = true;
                }
                else if (card.rearProduct.isSpecial && !User.isFastcoRole) {
                  let _onHandQty: number = 0;
                  if (card.rearProduct.inventory.onHandQtyMtl !== null)
                    _onHandQty += card.rearProduct.inventory.onHandQtyMtl;
                  if (card.rearProduct.inventory.onHandQtyCal !== null)
                    _onHandQty += card.rearProduct.inventory.onHandQtyCal;
                  if (card.rearProduct.inventory.onHandQtyPic !== null)
                    _onHandQty += card.rearProduct.inventory.onHandQtyPic;
                  if (rearQty > _onHandQty)
                    showSpecialNoBackOrderWarning = true;
                }
                else
                  showBackOrderWarning = true;
              }
            }
          }
        }
        else if (card.rearProduct.isDrilled) {
          if (card.rearProduct.onHandDetails && card.rearProduct.onHandDetails.length > 0) {
            let actualOnHand: number = 0;
            if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
              card.rearProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                .forEach(det => {
                  actualOnHand += det.qty;
                });
            else
              actualOnHand = card.rearProduct.inventory.onHandQtyMtl === null && card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyMtl;

            let actualLocalOnHand: number = actualOnHand;
            let _3PLQty: number = 0;
            let _3PLBlankQty: number = card.rearProduct.inventory.mtl3PLBlankStockQty;
            if (card.rearProduct.has3PL) {
              _3PLQty = card.rearProduct.onHandDetails.filter(d => d.label.endsWith('3PL.WarehouseDetail.MTL')).reduce((sum, current) => sum + current.qty, 0);
              actualLocalOnHand -= _3PLQty;
            }

            const processRequired = card.rearProduct.onHandDetails.find(d => d.label === "FC.Inventory.ProcessRequired.MTL").qty;
            let blankActualLocalOnHand: number = processRequired - _3PLBlankQty;
            if (User.canSplitOrders && User.allowShipFromCalgary) {
              if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.CAL"))
                actualOnHand += card.rearProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
              else if (card.rearProduct.inventory.onHandQtyCal !== null)
                actualOnHand += card.rearProduct.inventory.onHandQtyCal;
            }
            if (card.rearProduct.inventory.mtl3PLStockQty > 0 &&
              actualLocalOnHand >= 0 &&
              rearQty > actualLocalOnHand) {
              showMtl3PLWarning = true;
              showMtl3PLWarningRear = true;
            }
            if (rearQty > actualOnHand) {
              showWheelDrillWarning = true;
              if (actualOnHand + processRequired >= frontQty) {
                if (actualOnHand + blankActualLocalOnHand < frontQty) {
                  showMtl3PLBlankWarning = true;
                  showMtl3PLBlankWarningRear = true;
                }
              }
              else if (actualOnHand + processRequired < rearQty) {
                if (card.rearProduct.productStatus === "D")
                  showDiscontinuedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "P")
                  showParkedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "C") {
                  const _onOrderAvailQtyEast = card.rearProduct.inventory.onOrderAvailQtyMTL === null && card.rearProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.rearProduct.inventory.onOrderAvailQtyMTL + card.rearProduct.inventory.onOrderAvailQtyPIC;
                  if (rearQty > _onOrderAvailQtyEast)
                    showClearanceNoBackOrderWarning = true;
                }
                else if (card.rearProduct.isSpecial && !User.isFastcoRole)
                  showSpecialNoBackOrderWarning = true;
                else
                  showBackOrderWarning = true;
              }
            }
          }
        }
        else if (User.canSplitOrders && User.allowShipFromCalgary) {
          let _onHandQty: number = 0;
          if (card.rearProduct.inventory.onHandQtyMtl !== null)
            _onHandQty += card.rearProduct.inventory.onHandQtyMtl;
          if (card.rearProduct.inventory.onHandQtyCal !== null)
            _onHandQty += card.rearProduct.inventory.onHandQtyCal;
          if (card.rearProduct.inventory.onHandQtyPic !== null)
            _onHandQty += card.rearProduct.inventory.onHandQtyPic;
          const hasStock = rearQty > _onHandQty;
          if (card.rearProduct.productStatus === "D" && hasStock)
            showDiscontinuedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "P" && hasStock)
            showParkedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "C" && hasStock) {
            let _onOrderAvailQty: number = 0;
            if (card.rearProduct.inventory.onOrderAvailQtyMTL !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyMTL;
            if (card.rearProduct.inventory.onOrderAvailQtyCAL !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyCAL;
            if (card.rearProduct.inventory.onOrderAvailQtyPIC !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyPIC;
            if (rearQty > _onOrderAvailQty)
              showClearanceNoBackOrderWarning = true;
          }
          else if (card.rearProduct.isSpecial && !User.isFastcoRole && hasStock)
            showSpecialNoBackOrderWarning = true;
          else if (rearQty > card.rearProduct.inventory.onHandQtyMtl)
            showBackOrderWarning = true;
          if (card.rearProduct.inventory.mtl3PLStockQty > 0 &&
            card.rearProduct.inventory.onHandQtyMtl - card.rearProduct.inventory.mtl3PLStockQty >= 0 &&
            rearQty > card.rearProduct.inventory.onHandQtyMtl - card.rearProduct.inventory.mtl3PLStockQty) {
            showMtl3PLWarning = true;
            showMtl3PLWarningRear = true;
          }
        }
        else if (rearQty > card.rearProduct.inventory.onHandQtyMtl + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic)) {
          if (card.rearProduct.productStatus === "D") {
            if (rearQty > card.rearProduct.inventory.onHandQtyCal)
              showDiscontinuedNoBackOrderWarning = true;
          }
          else if (card.rearProduct.productStatus === "P") {
            if (rearQty > card.rearProduct.inventory.onHandQtyCal)
              showParkedNoBackOrderWarning = true;
          }
          else if (card.rearProduct.productStatus === "C") {
            let _onOrderAvailQty: number = 0;
            if (card.rearProduct.inventory.onOrderAvailQtyMTL !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyMTL;
            if (card.rearProduct.inventory.onOrderAvailQtyCAL !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyCAL;
            if (card.rearProduct.inventory.onOrderAvailQtyPIC !== null)
              _onOrderAvailQty += card.rearProduct.inventory.onOrderAvailQtyPIC;
            if (rearQty > _onOrderAvailQty)
              showClearanceNoBackOrderWarning = true;
          }
          else if (card.rearProduct.isSpecial && !User.isFastcoRole) {
            let _onHandQty: number = 0;
            if (card.rearProduct.inventory.onHandQtyMtl !== null)
              _onHandQty += card.rearProduct.inventory.onHandQtyMtl;
            if (card.rearProduct.inventory.onHandQtyCal !== null)
              _onHandQty += card.rearProduct.inventory.onHandQtyCal;
            if (card.rearProduct.inventory.onHandQtyPic !== null)
              _onHandQty += card.rearProduct.inventory.onHandQtyPic;
            if (rearQty > _onHandQty)
              showSpecialNoBackOrderWarning = true;
          }
          else
            showBackOrderWarning = true;
        }
        else if (card.rearProduct.inventory.mtl3PLStockQty > 0 &&
          card.rearProduct.inventory.onHandQtyMtl - card.rearProduct.inventory.mtl3PLStockQty >= 0 &&
          rearQty > card.rearProduct.inventory.onHandQtyMtl - card.rearProduct.inventory.mtl3PLStockQty) {
          showMtl3PLWarning = true;
          showMtl3PLWarningRear = true;
        }

        if (showMtl3PLWarningRear || showMtl3PLBlankWarningRear) {
          if (card.rearProduct.warningNotes == null) {
            card.rearProduct.warningNotes = [];
          }
          if (!card.rearProduct.warningNotes.some(n => n === _3PLMessage))
            card.rearProduct.warningNotes.push(_3PLMessage);
        }
        else {
          if (card.rearProduct.warningNotes) {
            let ndx: number = card.rearProduct.warningNotes.findIndex(x => x === _3PLMessage);
            if (ndx > -1)
              card.rearProduct.warningNotes.splice(ndx, 1);
          }
        }

        if (card.rearProduct.inventory.procurementLeadTime !== null) {
          let msg = translateService.instant('FC.ProductWarningsNotes.ProcurementLeadTime').replace('[ProcurementLeadTime]', card.rearProduct.inventory.procurementLeadTime);
          warningsList.warnings.push(msg);
          showBackOrderWarning = false;
        }

        if (card.rearProduct.isSpecial) {
          if (card.productType === 'Wheel' || card.productTypeWarning === 'Wheel' || card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
            let actualOnHand: number = 0;

            if (card.rearProduct.onHandDetails && card.rearProduct.onHandDetails.length > 0) {
              const mtlStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.MTL');
              if (mtlStock)
                actualOnHand = mtlStock.qty
              else if (card.rearProduct.inventory)
                actualOnHand = card.rearProduct.inventory.onHandQtyMtl;

              const calStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.CAL');
              if (calStock)
                actualOnHand += calStock.qty
              else if (card.rearProduct.inventory)
                actualOnHand += card.rearProduct.inventory.onHandQtyCal;

              const picStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.PIC');
              if (picStock && picStock.qty !== null)
                actualOnHand += picStock.qty;
              else if (card.rearProduct.inventory && card.rearProduct.inventory.onHandQtyPic !== null)
                actualOnHand += card.rearProduct.inventory.onHandQtyPic;

            } else if (card.rearProduct.inventory) {
              actualOnHand = card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic !== null ? card.rearProduct.inventory.onHandQtyPic : 0);
            }

            const _isBraelin = card.productBrand.toUpperCase().includes('BRAELIN');
            if (_isBraelin)
              actualOnHand = card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal;

            if (rearQty > actualOnHand) {
              warningsList.isOnSaleQtyMoreOnHand = true;
              warningsList.warnings.push(translateService.instant('FC.ProductWarningsNotes.OnSaleAvailableOnHand'));
            }
          }
        }

      }
    }//Calgary
    else if (card.frontProduct.defaultWarehouse === "CGY" || card.frontProduct.defaultWarehouse === "CAL") {
      if (card.frontProduct.hasAlternateWarehouseCal) {
        if (card.frontProduct.onHandDetails && card.frontProduct.onHandDetails.length > 0) {
          let actualOnHand = card.frontProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
          let alternateWarehouse = card.frontProduct.onHandDetails.find(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")).qty;
          let gtQty = 0;
          if (card.frontProduct.onHandDetails.some(d => d.label.startsWith("GT") && d.label.endsWith("AltDetail.CAL"))) {
            card.frontProduct.onHandDetails.filter(d => d.label.startsWith("GT") && d.label.endsWith("AltDetail.CAL"))
              .forEach(det => {
                gtQty += det.qty;
              });
          }

          if (User.canSplitOrders) {
            if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
              card.frontProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                .forEach(det => {
                  actualOnHand += det.qty;
                });
            if (card.frontProduct.onHandDetails.some(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC")))
              card.frontProduct.onHandDetails.filter(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC"))
                .forEach(det => {
                  alternateWarehouse += det.qty;
                });
          }
          if (frontQty > actualOnHand) {
            if (card.frontProduct.inventory.onOrderAvailQtyCAL > 0) {
              if (leadTime == null) {
                leadTime = await settingService.getLeadTime(card.productBrand, card.frontProduct.defaultWarehouse).first().toPromise();
                diff = Date.parse(card.frontProduct.inventory.expectedDateCAL) - new Date().valueOf();
                diffInUOM = Math.floor(leadTime.unitOfMeasure === "D" ? diff / (60 * 60 * 24 * 1000) : leadTime.unitOfMeasure === "H" ? diff / (60 * 60 * 1000) : 0);
              }
              if (card.frontProduct.inventory.onOrderAvailQtyCAL < frontQty ||
                (card.frontProduct.inventory.onOrderAvailQtyCAL > frontQty && leadTime.value < diffInUOM))
                showAlternateWarehouseWarning = true;
            }
            else
                showAlternateWarehouseWarning = true;

            if (card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
                showAlternateWarehouseWarning = frontQty > actualOnHand + gtQty;
            }

            if (actualOnHand + alternateWarehouse < frontQty) {

              let actualOnHandEast = 0;
              if (card.frontProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
                card.frontProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                  .forEach(det => {
                    actualOnHandEast += det.qty;
                  });

              if (card.frontProduct.productStatus === "D" && actualOnHandEast < frontQty)
                showDiscontinuedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "P" && actualOnHandEast < frontQty)
                showParkedNoBackOrderWarning = true;
              else if (card.frontProduct.productStatus === "C" && actualOnHandEast < frontQty) {
                const _onOrderAvailQtyCAL = card.frontProduct.inventory.onOrderAvailQtyCAL;
                if (frontQty > _onOrderAvailQtyCAL)
                  showClearanceNoBackOrderWarning = true;
              }
              else if (frontQty <= card.frontProduct.inventory.onHandQtyMtl)
                showShipfromMTLWarning = true;
              else if (card.frontProduct.isSpecial && !User.isFastcoRole) {
                if (frontQty > card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic))
                  showSpecialNoBackOrderWarning = true;
              }
              else
                showBackOrderWarning = true;
            }
          }
        }
      }
      else if (User.canSplitOrders) {
        const hasStock = frontQty > card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic);
        if (card.frontProduct.productStatus === "D" && hasStock)
          showDiscontinuedNoBackOrderWarning = true;
        else if (card.frontProduct.productStatus === "P" && hasStock)
          showParkedNoBackOrderWarning = true;
        else if (card.frontProduct.productStatus === "C" && hasStock) {
          const _onOrderAvailQty = card.frontProduct.inventory.onOrderAvailQtyMTL + card.frontProduct.inventory.onOrderAvailQtyCAL + (card.frontProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.frontProduct.inventory.onOrderAvailQtyPIC);
          if (frontQty > _onOrderAvailQty)
            showClearanceNoBackOrderWarning = true;
        }
        else if (card.frontProduct.isSpecial && !User.isFastcoRole && hasStock)
          showSpecialNoBackOrderWarning = true;
        else if (frontQty > card.frontProduct.inventory.onHandQtyCal && frontQty <= card.frontProduct.inventory.onHandQtyMtl)
          showShipfromMTLWarning = true;
        else if (frontQty > card.frontProduct.inventory.onHandQtyCal)
          showBackOrderWarning = true;
      }
      else if (frontQty > card.frontProduct.inventory.onHandQtyCal) {
        if (card.frontProduct.productStatus === "D" && frontQty > card.frontProduct.inventory.onHandQtyMtl + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic))
          showDiscontinuedNoBackOrderWarning = true;
        else if (card.frontProduct.productStatus === "P" && frontQty > card.frontProduct.inventory.onHandQtyMtl + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic))
          showParkedNoBackOrderWarning = true;
        else if (card.frontProduct.productStatus === "C" && frontQty > card.frontProduct.inventory.onHandQtyMtl + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic)) {
          const _onOrderAvailQtyEast = card.frontProduct.inventory.onOrderAvailQtyMTL + (card.frontProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.frontProduct.inventory.onOrderAvailQtyPIC);
          if (frontQty > _onOrderAvailQtyEast)
            showClearanceNoBackOrderWarning = true;
        }
        else if (frontQty <= card.frontProduct.inventory.onHandQtyMtl)
          showShipfromMTLWarning = true;
        else if (card.frontProduct.isSpecial && !User.isFastcoRole) {
          if (frontQty > card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic))
            showSpecialNoBackOrderWarning = true;
        }
        else
          showBackOrderWarning = true;
      }

      if (card.frontProduct.inventory.procurementLeadTime !== null) {
        let msg = translateService.instant('FC.ProductWarningsNotes.ProcurementLeadTime').replace('[ProcurementLeadTime]', card.frontProduct.inventory.procurementLeadTime);
        warningsList.warnings.push(msg);
        showBackOrderWarning = false;
      }



      if (card.frontProduct.isSpecial) {
        const _isTire = card.productType === 'Tire' || card.productTypeWarning === 'Tire';
        const _isWheel = card.productType === 'Wheel' || card.productTypeWarning === 'Wheel';

        if (_isTire || _isWheel) {
          let actualOnHand = 0;
          
          if (card.frontProduct.onHandDetails && card.frontProduct.onHandDetails.length > 0) {
            const mtlStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.MTL');
            if (mtlStock)
              actualOnHand = mtlStock.qty;
            else if (card.frontProduct.inventory)
              actualOnHand = card.frontProduct.inventory.onHandQtyMtl;

            const calStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.CAL');
            if (calStock)
              actualOnHand += calStock.qty

            if (_isWheel) {
              let calAlternateStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.AlternateWarehouse.CAL');

              if (!calAlternateStock)
                calAlternateStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.ProcessRequired.MTL');

              if (calAlternateStock)
                actualOnHand += calAlternateStock.qty;
            }

            if (!calStock && card.frontProduct.inventory)
              actualOnHand += card.frontProduct.inventory.onHandQtyCal;

            const picStock = card.frontProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.PIC');
            if (picStock && picStock.qty !== null)
              actualOnHand += picStock.qty;
            else if (card.frontProduct.inventory && card.frontProduct.inventory.onHandQtyPic !== null)
              actualOnHand += card.frontProduct.inventory.onHandQtyPic;
          } else if (card.frontProduct.inventory) {
            actualOnHand = card.frontProduct.inventory.onHandQtyCal + card.frontProduct.inventory.onHandQtyMtl + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic);
          }

          const _isBraelin = card.productBrand.toUpperCase().includes('BRAELIN');
          if (_isBraelin)
            actualOnHand = card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal;

          if (frontQty > actualOnHand) {
            warningsList.isOnSaleQtyMoreOnHand = true;
            warningsList.warnings.push(translateService.instant('FC.ProductWarningsNotes.OnSaleAvailableOnHand'));
          }
        }
      }

      // Optional Key backorder validation
      var isKey = card.frontProduct.details.details.find(d => d.accessoryType === AccessoryCategory.Keys);
      if (isKey) {
        const isOptionalKey = card.frontProduct['isOptionalKey'] && card.frontProduct['isOptionalKey'] === false;
        if (isOptionalKey !== undefined && !isOptionalKey) {
          if (card.frontProduct.inventory) {
            let onHandQtyCal = card.frontProduct.inventory.onHandQtyCal;
            if (onHandQtyCal <= 0) {
              warningsList.warnings.push(translateService.instant('FC.Popup.OptionalKey.BackOrdered'));
              showBackOrderWarning = false;
            }
          }
        }
      }// End

      if (card.rearProduct) {
        if (card.rearProduct.hasAlternateWarehouseCal) {
          if (card.rearProduct.onHandDetails && card.rearProduct.onHandDetails.length > 0) {
            let actualOnHand = card.rearProduct.onHandDetails.find(d => d.label === "FC.Inventory.StockAvailable.CAL").qty;
            let alternateWarehouse = card.rearProduct.onHandDetails.find(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.CAL")).qty;
            let gtQty = 0;
            if (card.rearProduct.onHandDetails.some(d => d.label.startsWith("GT") && d.label.endsWith("AltDetail.CAL"))) {
              card.rearProduct.onHandDetails.filter(d => d.label.startsWith("GT") && d.label.endsWith("AltDetail.CAL"))
                .forEach(det => {
                  gtQty += det.qty;
                });
            }
            if (User.canSplitOrders) {
              if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
                card.rearProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                  .forEach(det => {
                    actualOnHand += det.qty;
                  });
              if (card.rearProduct.onHandDetails.some(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC")))
                card.rearProduct.onHandDetails.filter(d => d.label.startsWith("FC.Inventory.AlternateWarehouse.MTL") || d.label.startsWith("FC.Inventory.AlternateWarehouse.PIC"))
                  .forEach(det => {
                    alternateWarehouse += det.qty;
                  });
            }
            if (rearQty > actualOnHand) {
              if (card.rearProduct.inventory.onOrderAvailQtyCAL > 0) {
                if (leadTime == null) {
                  leadTime = await settingService.getLeadTime(card.productBrand, card.rearProduct.defaultWarehouse).first().toPromise();
                  diff = Date.parse(card.rearProduct.inventory.expectedDateCAL) - new Date().valueOf();
                  diffInUOM = Math.floor(leadTime.unitOfMeasure === "D" ? diff / (60 * 60 * 24 * 1000) : leadTime.unitOfMeasure === "H" ? diff / (60 * 60 * 1000) : 0);
                }
                if (card.rearProduct.inventory.onOrderAvailQtyCAL < rearQty ||
                  (card.rearProduct.inventory.onOrderAvailQtyCAL > rearQty && leadTime.value < diffInUOM))
                  showAlternateWarehouseWarning = true;
              }
              else if (card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
                if (rearQty > actualOnHand + gtQty)
                  showAlternateWarehouseWarning = true;
              }
              else
                showAlternateWarehouseWarning = true;

              if (actualOnHand + alternateWarehouse < rearQty) {

                let actualOnHandEast = 0;
                if (card.rearProduct.onHandDetails.some(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC"))
                  card.rearProduct.onHandDetails.filter(d => d.label === "FC.Inventory.StockAvailable.MTL" || d.label === "FC.Inventory.StockAvailable.PIC")
                    .forEach(det => {
                      actualOnHandEast += det.qty;
                    });

                if (card.rearProduct.productStatus === "D" && actualOnHandEast < rearQty)
                  showDiscontinuedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "P" && actualOnHandEast < rearQty)
                  showParkedNoBackOrderWarning = true;
                else if (card.rearProduct.productStatus === "C" && actualOnHandEast < rearQty) {
                  const _onOrderAvailQtyCAL = card.rearProduct.inventory.onOrderAvailQtyCAL;
                  if (rearQty > _onOrderAvailQtyCAL)
                    showClearanceNoBackOrderWarning = true;
                }
                else if (rearQty <= card.rearProduct.inventory.onHandQtyMtl)
                  showShipfromMTLWarning = true;
                else if (card.rearProduct.isSpecial && !User.isFastcoRole) {
                  if (rearQty > card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic))
                    showSpecialNoBackOrderWarning = true;
                }
                else
                  showBackOrderWarning = true;

              }
            }
          }
        }
        else if (User.canSplitOrders) {
          const hasStock = rearQty > card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic);
          if (card.rearProduct.productStatus === "D" && hasStock)
            showDiscontinuedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "P" && hasStock)
            showParkedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "C" && hasStock) {
            const _onOrderAvailQty = card.rearProduct.inventory.onOrderAvailQtyMTL + card.rearProduct.inventory.onOrderAvailQtyCAL + (card.rearProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.rearProduct.inventory.onOrderAvailQtyPIC);
            if (rearQty > _onOrderAvailQty)
              showClearanceNoBackOrderWarning = true;
          }
          else if (card.rearProduct.isSpecial && !User.isFastcoRole && hasStock)
            showSpecialNoBackOrderWarning = true;
          else if (rearQty > card.rearProduct.inventory.onHandQtyCal && rearQty <= card.rearProduct.inventory.onHandQtyMtl)
            showShipfromMTLWarning = true;
          else if (rearQty > card.rearProduct.inventory.onHandQtyCal)
            showBackOrderWarning = true;
        }
        else if (rearQty > card.rearProduct.inventory.onHandQtyCal) {
          if (card.rearProduct.productStatus === "D" && rearQty > card.rearProduct.inventory.onHandQtyMtl + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic))
            showDiscontinuedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "P" && rearQty > card.rearProduct.inventory.onHandQtyMtl + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic))
            showParkedNoBackOrderWarning = true;
          else if (card.rearProduct.productStatus === "C" && rearQty > card.rearProduct.inventory.onHandQtyMtl + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic)) {
            const _onOrderAvailQtyEast = card.rearProduct.inventory.onOrderAvailQtyMTL + (card.rearProduct.inventory.onOrderAvailQtyPIC === null ? 0 : card.rearProduct.inventory.onOrderAvailQtyPIC);
            if (rearQty > _onOrderAvailQtyEast)
              showClearanceNoBackOrderWarning = true;
          }
          else if (rearQty <= card.rearProduct.inventory.onHandQtyMtl)
            showShipfromMTLWarning = true;
          else if (card.rearProduct.isSpecial && !User.isFastcoRole) {
            if (rearQty > card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic))
              showSpecialNoBackOrderWarning = true;
          }
          else
            showBackOrderWarning = true;
        }

        if (card.rearProduct.inventory.procurementLeadTime !== null) {
          let msg = translateService.instant('FC.ProductWarningsNotes.ProcurementLeadTime').replace('[ProcurementLeadTime]', card.rearProduct.inventory.procurementLeadTime);
          warningsList.warnings.push(msg);
          showBackOrderWarning = false;
        }

        if (card.rearProduct.isSpecial) {
          if (card.productType === 'Wheel' || card.productTypeWarning === 'Wheel' || card.productType === 'Tire' || card.productTypeWarning === 'Tire') {
            let actualOnHand = 0;
            
            if (card.rearProduct.onHandDetails && card.rearProduct.onHandDetails.length > 0) {
              const calStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.CAL');
              if (calStock)
                actualOnHand = calStock.qty
              else if (card.rearProduct.inventory)
                actualOnHand = card.rearProduct.inventory.onHandQtyCal;

              const mtlStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.MTL');
              if (mtlStock)
                actualOnHand += mtlStock.qty
              else if (card.rearProduct.inventory)
                actualOnHand += card.rearProduct.inventory.onHandQtyMtl;

              const picStock = card.rearProduct.onHandDetails.find(d => d.label === 'FC.Inventory.StockAvailable.PIC');
              if (picStock && picStock.qty !== null)
                actualOnHand += picStock.qty;
              else if (card.rearProduct.inventory && card.rearProduct.inventory.onHandQtyPic !== null)
                actualOnHand += card.rearProduct.inventory.onHandQtyPic;
            } else if (card.rearProduct.inventory) {
              actualOnHand = card.rearProduct.inventory.onHandQtyCal + card.rearProduct.inventory.onHandQtyMtl + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic);
            }

            const _isBraelin = card.productBrand.toUpperCase().includes('BRAELIN');
            if (_isBraelin)
              actualOnHand = card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal;

            if (rearQty > actualOnHand) {
              warningsList.isOnSaleQtyMoreOnHand = true;
              warningsList.warnings.push(translateService.instant('FC.ProductWarningsNotes.OnSaleAvailableOnHand'));
            }
          }
        }

      }
    }

    if (packageBuilderService != null &&  card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_WHEEL) {
      const frontWheelHardware = card.frontProduct.details.details.find(d => d.label === Constants.FLAG_MISSING_HARDWARE_DETAIL_LABEL).value;
      const rearWheelHardware = card.rearProduct != null
        ? card.rearProduct.details.details.find(d => d.label === Constants.FLAG_MISSING_HARDWARE_DETAIL_LABEL).value : '';
      if (frontWheelHardware === 'True' || rearWheelHardware === 'True') {
        const boltNutInfos = await packageBuilderService.WheelBoltsNutsInfo(card.frontProduct.longSKU, card.rearProduct ? card.rearProduct.longSKU : null).first().toPromise();
        const note = packageBuilderService.getBoltsNutsWarningMessage(boltNutInfos);
        warningsList.warnings.push(note);
        if (frontWheelHardware === 'True') {
          if (!card.frontProduct.warningNotes.some(n => n === note))
            card.frontProduct.warningNotes.push(note);
        }
        if (rearWheelHardware === 'True') {
          if (!card.rearProduct.warningNotes.some(n => n === note))
            card.rearProduct.warningNotes.push(note);
        }
      }
    }

    if (card.frontProduct.isNationalAccountItem && (card.productType === Constants.PRODUCT_TYPE_TIRE || card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_TIRE)) {
        let tireWarnMessage = translateService.instant('FC.ProductWarningsNotes.NATireWarning');

        //const customerId = sessionStorage.getItem("customerID");
        //const customerGroupId = sessionStorage.getItem("customerGroupID");
        //if (customerGroupId === "N-082" && customerId != "N-954267" || customerId == 'N-9171E') {
        //    tireWarnMessage = translateService.instant('FC.ProductWarningsNotes.CentralBillingAccountWarning');
        //}

        warningsList.warnings.push(tireWarnMessage);

    }

    if (card.frontProduct.accessoryType === AccessoryCategory.InstallationKit && packageBuilderService) {
      const model = packageBuilderService.getPackageBuilderModel();
      // console.log({model});
      const totalNutsNeeded = model.front.wheel.quantity * card.frontProduct.qtyPerWheel;
      const totalNutsSelected = frontQty * card.frontProduct.qtyPerWheel * 4;
      const kitQuantityMatches = totalNutsNeeded === totalNutsSelected;
      // console.log({totalNutsNeeded, totalNutsSelected, kitQuantityMatches});
      if (!kitQuantityMatches) {
        const installKitWarning = translateService.instant('FC.ProductWarningsNotes.InstallationKitWarning');
        warningsList.warnings.push(installKitWarning);
        if (!card.frontProduct.warningNotes.some(n => n === installKitWarning)) {
          card.frontProduct.warningNotes.push(installKitWarning);
        }
      }
    }

    if (showMtl3PLWarning) {
      const leadTime = await settingService.getMTL3PLLeadTime().first().toPromise();
      //const leadTimeUOM = leadTime.substring(leadTime.length - 1);
      //const leadTimeValue = leadTime.substring(0, leadTime.length - 1);
      warningsList.warnings.push(Helper.stringFormat(translateService.instant('FC.Popup.3PL'), leadTime.value, translateService.instant(`FC.LeadTime.${leadTime.unitOfMeasure}`)));
    }

    if (showMtl3PLBlankWarning) {
      const leadTime = await settingService.getMTL3PLLeadTime().first().toPromise();
      //const leadTimeUOM = leadTime.substring(leadTime.length - 1);
      //const leadTimeValue = leadTime.substring(0, leadTime.length - 1);
      warningsList.warnings.push(Helper.stringFormat(translateService.instant('FC.Popup.3PL.Input'), leadTime.value, translateService.instant(`FC.LeadTime.${leadTime.unitOfMeasure}`)));
    }

    if (showWheelDrillWarning &&
      !showDiscontinuedNoBackOrderWarning && !showClearanceNoBackOrderWarning && !showSpecialNoBackOrderWarning && !showParkedNoBackOrderWarning && mtlWheelDrillLeadTime != null) {
      //const wheelDrillLeadTime = await settingService.getWheelDrillLeadTime().first().toPromise();
      //const leadTimeUOM = wheelDrillLeadTime.substring(wheelDrillLeadTime.length - 1);
      //const leadTimeValue = wheelDrillLeadTime.substring(0, wheelDrillLeadTime.length - 1);

      let wheelDrillWarnMessage = '';

      if (card.productBrand.toLowerCase() === 'braelin')
        wheelDrillWarnMessage = Helper.stringFormat(translateService.instant('FC.Popup.WheelDrill.WithRestockingFee'), mtlWheelDrillLeadTime.value, translateService.instant(`FC.LeadTime.${mtlWheelDrillLeadTime.unitOfMeasure}`));
      else
        wheelDrillWarnMessage = Helper.stringFormat(translateService.instant('FC.Popup.WheelDrill'), mtlWheelDrillLeadTime.value, translateService.instant(`FC.LeadTime.${mtlWheelDrillLeadTime.unitOfMeasure}`));

      warningsList.warnings.push(wheelDrillWarnMessage);

    }

    if (showAlternateWarehouseWarning) {
      if (leadTime == null) {
        leadTime = card.frontProduct.defaultWarehouse === "CAL" ? card.frontProduct.tireLeadTimeDelayCAL : card.frontProduct.tireLeadTimeDelayMTL;
        if (leadTime == null)
          leadTime = await settingService.getLeadTime(card.productBrand, card.frontProduct.defaultWarehouse).first().toPromise();
        //if (leadTime == null || leadTime == '')
        //  leadTime = "72H";
        //leadTimeUOM = leadTime.substring(leadTime.length - 1);
        //leadTimeValue = leadTime.substring(0, leadTime.length - 1);
      }
      warningsList.warnings.push(translateService.instant('FC.Popup.AlternateWarehouse').replace('{0}', leadTime.value).replace('{1}', translateService.instant(`FC.LeadTime.${leadTime.unitOfMeasure}`)));
    }

    if (showDiscontinuedNoBackOrderWarning && card.frontProduct.longSKU.indexOf('Size') < 0
      && card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic) > 0
      && (card.rearProduct === null || card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic) > 0)) {
      warningsList.warnings.push(translateService.instant('FC.Popup.InvalidDiscontinuedQty'));
      warningsList.proceedToNextStep = false;
    }

    if (showClearanceNoBackOrderWarning && card.frontProduct.longSKU.indexOf('Size') < 0) {
      warningsList.warnings.push(translateService.instant('FC.Popup.InvalidClearanceQty'));
      warningsList.proceedToNextStep = false;
    }

    if (showSpecialNoBackOrderWarning && card.frontProduct.longSKU.indexOf('Size') < 0) {
      warningsList.warnings.push(translateService.instant('FC.Popup.InvalidSpecialQty'));
      warningsList.proceedToNextStep = false;
    }

    if (showParkedNoBackOrderWarning && card.frontProduct.longSKU.indexOf('Size') < 0) {
      let message = translateService.instant('FC.Popup.InvalidParkedQty');
      if ((card.frontProduct.inventory.onHandQtyMtl + card.frontProduct.inventory.onHandQtyCal + (card.frontProduct.inventory.onHandQtyPic === null ? 0 : card.frontProduct.inventory.onHandQtyPic) > 0) ||
        (card.rearProduct !== null && card.rearProduct.inventory.onHandQtyMtl + card.rearProduct.inventory.onHandQtyCal + (card.rearProduct.inventory.onHandQtyPic === null ? 0 : card.rearProduct.inventory.onHandQtyPic) > 0)) {
        message += translateService.instant('FC.Popup.InvalidQty.AdjustQty');
      }
      warningsList.warnings.push(message);
      warningsList.proceedToNextStep = false;
    }

    if (showShipfromMTLWarning) {
      warningsList.warnings.push(translateService.instant('FC.Popup.ShipFromMTL'));
      //warningsList.proceedToNextStep = false;
    }

    if (card.frontProduct.inventory.procurementLeadTime !== null) {
      let msg = translateService.instant('FC.ProductWarningsNotes.ProcurementLeadTime').replace('[ProcurementLeadTime]', card.frontProduct.inventory.procurementLeadTime);
      warningsList.warnings.push(msg);
    } else if (showBackOrderWarning && card.frontProduct.longSKU.indexOf('Size') < 0 &&
      !showDiscontinuedNoBackOrderWarning && !showClearanceNoBackOrderWarning && !showSpecialNoBackOrderWarning && !showParkedNoBackOrderWarning) {
      if (card.frontProduct.alternateProductList !== null)
        warningsList.showAlternateOptionsForBackOrder = true;
      else
        warningsList.warnings.push(translateService.instant('FC.Popup.BackorderOrNot'));
    }
    if (card.frontProduct.accessoryType === AccessoryCategory.BilletWheelAdapters && card.frontProduct.details.details.find(d => d.label === Constants.HUBEXTENSION_LABEL) !== undefined && (card.frontProduct.details.details.find(d => d.label === Constants.HUBEXTENSION_LABEL).value.toLowerCase() == "yes" || card.frontProduct.details.details.find(d => d.label === Constants.HUBEXTENSION_LABEL).value.toLowerCase() == "oui")) {
      showSpacerWarning = true;
    }
    else if (card.frontProduct.accessoryType === AccessoryCategory.WheelSpacers && card.frontProduct.details.details.find(d => d.label === Constants.STEP_BORE_LABEL) !== undefined && (card.frontProduct.details.details.find(d => d.label === Constants.STEP_BORE_LABEL).value.toLowerCase() == "yes" || card.frontProduct.details.details.find(d => d.label === Constants.STEP_BORE_LABEL).value.toLowerCase() == "oui")) {
      showSpacerWarning = true;
    }
    if (showSpacerWarning) {

      let msg = "";
      let msgAlt = "";
      if (card.frontProduct.accessoryType === AccessoryCategory.WheelSpacers) {
        msg = "[customtitle]FC.ProductWarningsNotes.StepBoreSpacerTitle;" + translateService.instant('FC.ProductWarningsNotes.StepBoreSpacer').replace("[productimage]", card.frontProduct.accessoryType);
        msgAlt = translateService.instant('FC.ProductWarningsNotes.StepBoreSpacerAlt');
      }
      else {
        msg = "[customtitle]FC.ProductWarningsNotes.StepBoreSpacerTitle;" + translateService.instant('FC.ProductWarningsNotes.StepBoreBillet').replace("[productimage]", card.frontProduct.accessoryType);
        msgAlt = translateService.instant('FC.ProductWarningsNotes.StepBoreBilletAlt');
      }
      if (card.frontProduct.warningNotes == null) {
        card.frontProduct.warningNotes = [];
      }
      if (!card.frontProduct.warningNotes.some(n => n === msgAlt))
        card.frontProduct.warningNotes.push(msgAlt);
      if (!warningsList.warnings.some(n => n === msg))
        warningsList.warnings.push(msg);
    }
    //Conditions preventing the product to be added (invalid qty on blem)
    if ((card.frontProduct.isBlem ||
      (card.rearProduct && card.rearProduct.isBlem)) &&
      showBackOrderWarning) {
      const message = translateService.instant('FC.Popup.InvalidBlemQty');
      if (this.productNotesService)
        this.productNotesService.validateProductWarningsAckNormalPopup([message], null, '', '').then(ack => { });
    }
    else {
      if (card.frontProduct.finishAbreviation != null && card.frontProduct.finishAbreviation.includes('PVD')) {
        warningsList.warnings.push(translateService.instant('FC.Popup.PVDWarning'));
      }

      if (card.frontProduct.isAggressiveFitment || (card.rearProduct != null && card.rearProduct.isAggressiveFitment)) {
        let productType = "";
        if (card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_WHEEL) {
          productType = "Wheels";
        }
        else if (card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_TIRE) {
          productType = "Tires";
        }
        warningsList.warnings.push(translateService.instant(`FC.Popup.AggressiveFitment.${productType}`));

        if (card.frontProduct.isAggressiveFitment) {
          const note = translateService.instant(`FC.Popup.AggressiveFitment.${productType}.Note`);
          if (!card.frontProduct.warningNotes.some(n => n === note))
            card.frontProduct.warningNotes.push(note);
        }
        if (card.rearProduct != null && card.rearProduct.isAggressiveFitment) {
          if (card.rearProduct.warningNotes == null) {
            card.rearProduct.warningNotes = [];
          }
          const note = translateService.instant(`FC.Popup.AggressiveFitment.${productType}.Note`);
          if (!card.rearProduct.warningNotes.some(n => n === note))
            card.rearProduct.warningNotes.push(note);
        }
      }

      if (packageBuilderService != null) {
        if (card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_WHEEL) {
          if (!card.frontProduct.isAggressiveFitment) {
            const note = translateService.instant(card.frontProduct.confirmedFitment ? 'FC.ProductWarningsNotes.GuaranteedFitment' : 'FC.ProductWarningsNotes.RecommendedFitment');
            if (!card.frontProduct.warningNotes.some(n => n === note))
              card.frontProduct.warningNotes.push(note);
          }
          if (card.rearProduct != null && !card.rearProduct.isAggressiveFitment) {
            if (card.rearProduct.warningNotes == null) {
              card.rearProduct.warningNotes = [];
            }
            const note = translateService.instant(card.rearProduct.confirmedFitment ? 'FC.ProductWarningsNotes.GuaranteedFitment' : 'FC.ProductWarningsNotes.RecommendedFitment');
            if (!card.rearProduct.warningNotes.some(n => n === note))
              card.rearProduct.warningNotes.push(note);
          }

          if (card.frontProduct.isAggressiveFitment && !card.frontProduct.confirmedFitment) {
            const note = translateService.instant('FC.ProductWarningsNotes.RecommendedFitment');
            if (!card.frontProduct.warningNotes.some(n => n === note))
              card.frontProduct.warningNotes.push(note);
          }

          if (card.rearProduct !== null && card.rearProduct.isAggressiveFitment && !card.rearProduct.confirmedFitment) {
            const note = translateService.instant('FC.ProductWarningsNotes.RecommendedFitment');
            if (!card.rearProduct.warningNotes.some(n => n === note))
              card.rearProduct.warningNotes.push(note);
          }

          const oemData = packageBuilderService.getPackageBuilderOEMData();
          const frontOffset = card.frontProduct.details.details.find(d => d.label === Constants.OFFSET_DETAIL_LABEL).value;
          const rearOffset = card.rearProduct !== null ? card.rearProduct.details.details.find(d => d.label === Constants.OFFSET_DETAIL_LABEL).value:'';
          const oeTireSizeFitment = await packageBuilderService.WheelOETireSizeFitment(card.frontProduct.longSKU, card.rearProduct ? card.rearProduct.longSKU : null, frontOffset, rearOffset).first().toPromise();
          packageBuilderService.oeTireSizeFitsAggressive = false;
          packageBuilderService.oeTireSizeFitmentNote = new OETireSizeFitmentNote();
          if (oeTireSizeFitment !== null) {
            const frontSize = card.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Size").value;
            const frontDiameter = frontSize.indexOf('x') >= 0 ? frontSize.substring(0, frontSize.indexOf('x')).trim() : '';
            const rearSize = card.rearProduct !== null ? card.rearProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Size").value : '';
            const rearDiameter = rearSize.indexOf('x') >= 0 ? rearSize.substring(0, rearSize.indexOf('x')).trim() : frontDiameter;

            let fnote = '', rnote = '', fmsg = '', rmsg = '', msg='';
            if (oeTireSizeFitment.frontFitment.notFit || oeTireSizeFitment.frontFitment.fitAggressive || oeTireSizeFitment.frontFitment.selectedVehicleOETireNotFit || oeTireSizeFitment.rearFitment.notFit || oeTireSizeFitment.rearFitment.fitAggressive || oeTireSizeFitment.rearFitment.selectedVehicleOETireNotFit) {
              //Front
              if (oeTireSizeFitment.frontFitment.notFit) {
                msg = translateService.instant('FC.Popup.OETireNoFit').replace('{0}', frontDiameter);
                if (oeTireSizeFitment.frontFitment.notFitCode !== 0) {
                  if (oeTireSizeFitment.frontFitment.notFitCode === 1) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code1.RimWidth').replace('{0}', frontDiameter);
                  }
                  else if (oeTireSizeFitment.frontFitment.notFitCode === 2) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code2.OD').replace('{0}', frontDiameter);
                  }
                  else if (oeTireSizeFitment.frontFitment.notFitCode === 3) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code3.InnerLip').replace('{0}', frontDiameter);
                  }
                }
              }
              else if (oeTireSizeFitment.frontFitment.fitAggressive) {
                if (oeTireSizeFitment.frontFitment.fitAggressiveCode === 1)
                  msg = translateService.instant('FC.Popup.OETireFitAggressive.Code1').replace('{0}', frontDiameter);
                else
                  msg = translateService.instant('FC.Popup.OETireFitAggressive.Code2').replace('{0}', frontDiameter);
                packageBuilderService.oeTireSizeFitsAggressive = true
              }
              else if (oeTireSizeFitment.frontFitment.selectedVehicleOETireNotFit) {
                const frontOETireSize = oemData.groups.find(g => g.groupName === 'Tires').items.find(i => i.itemName === 'TireSize').itemValue;
                msg = translateService.instant('FC.Popup.OETireSelectedVehicleNoFit').replace('{0}', frontDiameter).replace('{1}', frontOETireSize);
              }
              if (msg !== '') {
                fmsg = translateService.instant('FC.Popup.OETireFrontAxle').replace('{0}', msg);
                fnote = translateService.instant('FC.Stagger.Label.Front.Axle') + ' - ' + msg;
              }
              //Rear
              msg = '';
              if (oeTireSizeFitment.rearFitment.notFit) {
                msg = translateService.instant('FC.Popup.OETireNoFit').replace('{0}', rearDiameter);
                if (oeTireSizeFitment.rearFitment.notFitCode !== 0) {
                  if (oeTireSizeFitment.rearFitment.notFitCode === 1) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code1.RimWidth').replace('{0}', rearDiameter);
                  }
                  else if (oeTireSizeFitment.rearFitment.notFitCode === 2) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code2.OD').replace('{0}', rearDiameter);
                  }
                  else if (oeTireSizeFitment.rearFitment.notFitCode === 3) {
                    msg = translateService.instant('FC.Popup.OETireNoFit.Code3.InnerLip').replace('{0}', rearDiameter);
                  }
                }
              }
              else if (oeTireSizeFitment.rearFitment.fitAggressive) {
                if (oeTireSizeFitment.rearFitment.fitAggressiveCode ===1)
                  msg = translateService.instant('FC.Popup.OETireFitAggressive.Code1').replace('{0}', rearDiameter);
                else
                  msg = translateService.instant('FC.Popup.OETireFitAggressive.Code2').replace('{0}', rearDiameter);
                packageBuilderService.oeTireSizeFitsAggressive = true
              }
              else if (oeTireSizeFitment.rearFitment.selectedVehicleOETireNotFit) {
                const rearOETireSize = oemData.groups.find(g => g.groupName === 'Tires').items.find(i => i.itemName === 'TireSize').itemValueRear;
                msg = translateService.instant('FC.Popup.OETireSelectedVehicleNoFit').replace('{0}', rearDiameter).replace('{1}', rearOETireSize);
              }
              if (msg !== '') {
                rmsg = translateService.instant('FC.Popup.OETireRearAxle').replace('{0}', msg);;
                rnote = translateService.instant('FC.Stagger.Label.Rear.Axle') + ' - ' + msg;
              }

              if (fmsg !== '')
                rmsg = rmsg.replace('<br/>', '');

              warningsList.warnings.push(translateService.instant('FC.Popup.OETireNotValid') + fmsg + rmsg);

              var fs = frontSize.substring(frontSize.indexOf('x') + 1).trim();
              var rs = rearSize.substring(rearSize.indexOf('x') + 1).trim();

              if ((rs !== '' && parseFloat(rs) !== parseFloat(fs)) || (rearDiameter !== '' && frontDiameter !== rearDiameter)) {
                if (rnote !== '' && !card.rearProduct.warningNotes.some(n => n === rnote)) {
                  if (card.rearProduct.warningNotes == null) {
                    card.rearProduct.warningNotes = [];
                  }
                  card.rearProduct.warningNotes.push(rnote);
                }
                packageBuilderService.oeTireSizeFitmentNote.rear = rnote;
                if (fnote !== '' && !card.frontProduct.warningNotes.some(n => n === fnote)) {
                  card.frontProduct.warningNotes.push(fnote);
                }
                packageBuilderService.oeTireSizeFitmentNote.front = fnote;
              }
              else {
                let note = '';
                if (fnote !== '' && rnote !== '')
                  note = fnote + '<br/>' + rnote;
                else if (fnote !== '')
                  note = fnote;
                else
                  note = rnote;
                if (!card.frontProduct.warningNotes.some(n => n === note))
                  card.frontProduct.warningNotes.push(note);
                packageBuilderService.oeTireSizeFitmentNote.front = note;
              }
            }
          }
          const frontOESeatSame = card.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.MatchesOESeat").value;
          const rearOESeatSame = card.rearProduct != null
            ? card.rearProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.MatchesOESeat").value : '';
          packageBuilderService.setWheelSeat(card.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Seat").value);
          if (frontOESeatSame === 'False' || rearOESeatSame === 'False') {
            const note = translateService.instant('FC.ProductWarningsNotes.WheelSeatDifferentFromOE');
            if (!card.frontProduct.warningNotes.some(n => n === note))
              card.frontProduct.warningNotes.push(note);
          }
         
          let hubCentric = false, isSteel = Helper.isSteelProduct(card.frontProduct.details);
          if (card.frontProduct.isHubCentric != null)
            hubCentric = card.frontProduct.isHubCentric;
          if (card.rearProduct != null) {
            if (card.rearProduct.isHubCentric != null)
              hubCentric = card.rearProduct.isHubCentric;
            isSteel = Helper.isSteelProduct(card.rearProduct.details);
          }
          if (!hubCentric && isSteel) {
            const note = translateService.instant('FC.Popup.NonHubCentricSteelWheel');
            warningsList.warnings.push(note + translateService.instant('FC.Popup.NonHubCentricSteelWheel.Prompt'));
            if (card.frontProduct.warningNotes == null) {
              card.frontProduct.warningNotes = [];
            }
            if (!card.frontProduct.warningNotes.some(n => n === note))
              card.frontProduct.warningNotes.push(note);
            if (card.rearProduct != null) {
              if (card.rearProduct.warningNotes == null) {
                card.rearProduct.warningNotes = [];
              }
              if (!card.rearProduct.warningNotes.some(n => n === note))
                card.rearProduct.warningNotes.push(note);
            }
          }

          if (packageBuilderService.getMakeYearModel().isSummerSeason) {
            const frontWheelDownsize = card.frontProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Downsize").value;
            const rearWheelDownsize = card.rearProduct != null
              ? card.rearProduct.details.details.find(d => d.label === "FC.ProductDetail.Label.Downsize").value : '';
            if (frontWheelDownsize === 'True' || rearWheelDownsize === 'True') {
              const note = translateService.instant('FC.ProductWarningsNotes.Downsize');
              warningsList.warnings.push(note);
              if (frontWheelDownsize === 'True') {
                if (!card.frontProduct.warningNotes.some(n => n === note))
                  card.frontProduct.warningNotes.push(note);
              }
              if (rearWheelDownsize === 'True') {
                if (!card.rearProduct.warningNotes.some(n => n === note))
                  card.rearProduct.warningNotes.push(note);
              }
            }
          }
        }
        includeNotWinterWheelWarning = !packageBuilderService.getMakeYearModel().isSummerSeason;
      }

      if (includeNotWinterWheelWarning) {
        if (card.productTypeWarning === Constants.PRODUCT_TYPE_WARNING_WHEEL) { //not winter wheel warning
          const note = translateService.instant('FC.ProductWarningsNotes.NotWinterWheel');
          if (!card.frontProduct.isWinterWheel) {
            //Helper.log("front wheel not winter wheel")
            if (!card.frontProduct.warningNotes.some(n => n === note))
              card.frontProduct.warningNotes.push(note);
          }
          else if (card.rearProduct && !card.rearProduct.isWinterWheel) {
            if (!card.rearProduct.warningNotes.some(n => n === note))
              card.rearProduct.warningNotes.push(note);
          }
          //if (!card.frontProduct.isWinterWheel || (card.rearProduct && !card.rearProduct.isWinterWheel))
          //Helper.log("front and rear wheels not winter wheel")
          //warningsList.warnings.push(translateService.instant('FC.Popup.NotWinterWheel'));
        }
      }
    }

    // TPMS warning messages
    let frontSuffix = "", rearSuffix = "";
    if (card.frontProduct.longSKU === "SC33500" || card.frontProduct.longSKU === "SC33700") {
      frontSuffix = ".EZ";
    }
    else if (card.frontProduct.longSKU === "MXSA001" || card.frontProduct.longSKU === "MXSR001") {
      frontSuffix = ".MAX";
    } else if (card.frontProduct.longSKU === "DYA001" || card.frontProduct.longSKU === "DYR001") {
      frontSuffix = ".DYA";
    }

    if (frontSuffix.length > 0) {
      if (hasVehicleInfo) {
        showTPMSConfiguredWarning = true;
        const note = translateService.instant('FC.ProductWarningsNotes.TPMSConfigured' + frontSuffix);
        if (!card.frontProduct.warningNotes.some(n => n === note))
          card.frontProduct.warningNotes.push(note);
      }
      else {
        showTPMSConfigurationRequiredWarning = true;
        const note = translateService.instant('FC.ProductWarningsNotes.TPMSConfigurationRequired' + frontSuffix);
        if (!card.frontProduct.warningNotes.some(n => n === note))
          card.frontProduct.warningNotes.push(note);
      }
    }

    if (card.rearProduct) {
      if (card.rearProduct.longSKU === "SC33500" || card.rearProduct.longSKU === "SC33700") {
        rearSuffix = ".EZ";
      }
      else if (card.rearProduct.longSKU === "MXSA001" || card.rearProduct.longSKU === "MXSR001") {
        rearSuffix = ".MAX";
      } else if (card.frontProduct.longSKU === "DYA001" || card.frontProduct.longSKU === "DYR001") {
        frontSuffix = ".DYA";
      }
      if (rearSuffix.length > 0) {
        if (card.rearProduct.warningNotes == null) {
          card.rearProduct.warningNotes = [];
        }
        if (hasVehicleInfo) {
          showTPMSConfiguredWarning = true;
          const note = translateService.instant('FC.ProductWarningsNotes.TPMSConfigured' + rearSuffix);
          if (!card.rearProduct.warningNotes.some(n => n === note))
            card.rearProduct.warningNotes.push(note);
        }
        else {
          showTPMSConfigurationRequiredWarning = true;
          const note = translateService.instant('FC.ProductWarningsNotes.TPMSConfigurationRequired' + rearSuffix);
          if (!card.rearProduct.warningNotes.some(n => n === note))
            card.rearProduct.warningNotes.push(note);
        }
      }
    }

    if (showTPMSConfiguredWarning) {
      if (rearSuffix.length == 0 || frontSuffix === rearSuffix)
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigured' + frontSuffix));
      else {
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigured' + frontSuffix));
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigured' + rearSuffix));
      }
    }
    if (showTPMSConfigurationRequiredWarning) {
      if (rearSuffix.length == 0 || frontSuffix === rearSuffix)
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigurationRequired' + frontSuffix));
      else {
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigurationRequired' + frontSuffix));
        warningsList.warnings.push(translateService.instant('FC.Popup.TPMSConfigurationRequired' + rearSuffix));
      }
    }

    // HasSpaceForWeights
    if (hasVehicleInfo && (card.productType === 'Wheel' || card.productTypeWarning === 'Wheel')) {
      const _notes = translateService.instant('FC.Popup.HasSpaceForWeights');
      let _hasSpaceForWeights = card.frontProduct.hasSpaceForWeights === null || card.frontProduct.hasSpaceForWeights;

      if (!_hasSpaceForWeights) {
        if (!card.frontProduct.warningNotes.some(n => n === _notes))
          card.frontProduct.warningNotes.push(_notes);
      }
      
      if (card.rearProduct) {
        const _rearHasSpaceForWeights = card.rearProduct.hasSpaceForWeights === null || card.rearProduct.hasSpaceForWeights;
        if (!_rearHasSpaceForWeights) {
          _hasSpaceForWeights = false;

          if (!card.rearProduct.warningNotes.some(n => n === _notes) && !_hasSpaceForWeights)
            card.rearProduct.warningNotes.push(_notes);
        }
      }

      if (!_hasSpaceForWeights)
        warningsList.warnings.push(_notes);
    }

    // ProcurementTypeCode
    if ((card.productType === 'Wheel' || card.productTypeWarning === 'Wheel')) {
      const ltNotes: string = translateService.instant('FC.LeadTime.Delay.InternalNotes');
      let msg: string = '';
      if (mtlWheelDrillLeadTime != null)
        msg = Helper.stringFormat(ltNotes, mtlWheelDrillLeadTime.value, translateService.instant(`FC.LeadTime.${mtlWheelDrillLeadTime.unitOfMeasure}`));

      let restockingMsg = '';
      if (card.productBrand.toLowerCase() === 'braelin')
        restockingMsg = translateService.instant('FC.LeadTime.Delay.RestockingFee.InternalNotes');

      if (card.frontProduct.inventory.procurementTypeCode === '1') {
        const actualOnHand = card.frontProduct.inventory['onHandActualQtyMtl'];
        if (frontQty > actualOnHand) {

          if (!card.frontProduct.warningNotes.some(n => n === msg))
            card.frontProduct.warningNotes.push(msg);

          if (!card.frontProduct.warningNotes.some(n => n === restockingMsg) && restockingMsg !== '')
            card.frontProduct.warningNotes.push(restockingMsg);

        } else {
          if (card.frontProduct.warningNotes) {
            let ndx: number = card.frontProduct.warningNotes.findIndex(x => x === msg);
            if (ndx > -1)
              card.frontProduct.warningNotes.splice(ndx, 1);

            if (restockingMsg !== '') {
              ndx = card.frontProduct.warningNotes.findIndex(x => x === restockingMsg);
              if (ndx > -1)
                card.frontProduct.warningNotes.splice(ndx, 1);
            }
          }
        }
      }

      if (card.rearProduct !== null && card.rearProduct.inventory.procurementTypeCode === '1') {
        const actualOnHand = card.rearProduct.inventory['onHandActualQtyMtl'];
        if (frontQty > actualOnHand) {
          if (card.rearProduct.warningNotes == null) {
            card.rearProduct.warningNotes = [];
          }

          if (!card.rearProduct.warningNotes.some(n => n === msg))
            card.rearProduct.warningNotes.push(msg);

          if (!card.rearProduct.warningNotes.some(n => n === restockingMsg) && restockingMsg !== '')
            card.rearProduct.warningNotes.push(restockingMsg);

        } else {
          if (card.rearProduct.warningNotes) {
            let ndx: number = card.rearProduct.warningNotes.findIndex(x => x === msg);
            if (ndx > -1)
              card.rearProduct.warningNotes.splice(ndx, 1);

            if (restockingMsg !== '') {
              ndx = card.rearProduct.warningNotes.findIndex(x => x === restockingMsg);
              if (ndx > -1)
                card.rearProduct.warningNotes.splice(ndx, 1);
            }
          }
        }
      }
    }

    warningsList.warnings = warningsList.warnings.filter(this.toDistinctMessages);
    return warningsList;
  }

  static toDistinctMessages(value, index, self) {
    return self.indexOf(value) === index;
  }
}
